import { Context } from '@vue-storefront/core';
import {
  OAuthToken,
  AUTH_USER_TOKEN_COOKIE_NAME,
  getAuthCookieOptions
} from '@vsf-enterprise/sapcc-api';

export const refreshUserToken = async (context: Context): Promise<OAuthToken | null> => {
  const { api } = context.$vsf.$sapcc;
  const token = await api.OAuthUserTokenRefresh();

  if (process.server) {
    context.app.$cookies.set(
      AUTH_USER_TOKEN_COOKIE_NAME,
      JSON.stringify(token),
      getAuthCookieOptions()
    );

    return token;
  }

  return null;
};
